import { render, staticRenderFns } from "./BranchWiseDispatchedReport.vue?vue&type=template&id=c6a13bb6&"
import script from "./BranchWiseDispatchedReport.vue?vue&type=script&lang=js&"
export * from "./BranchWiseDispatchedReport.vue?vue&type=script&lang=js&"
import style0 from "./BranchWiseDispatchedReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports